import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Adding the Editor",
description: "Embed the Freon editor into your custom web page. Learn how to connect the editor to the WebappConfigurator, apply Flowbite and Tailwind CSS styling, and enable dark mode support.",
tags: [ "Freon", "Svelte", "Integration", "Editor", "Flowbite", "Tailwind", "dark mode", "WebappConfigurator", "FreonComponent", "CSS", "Freon4DSL", "core-svelte"] ,
modifiedTime: "2025-11-07T17:20:18.645Z",
publishedTime: "2025-11-07T17:20:18.645Z"
    }
  };
};